import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { discountFormAction, typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updateDiscountSagaAction } from "../../redux/sagaActions";

const DiscountForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const discountForm = useSelector(state => state.discountForm);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(typeOpenSettingsFormAction('')) } />
                        <div className="form__title">{ discountForm.id ? 'Редактирование скидки' : 'Добавление скидки' }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название скидки</div>
                        <input type="text" className="input" value={ discountForm.name }
                               onInput={ event => dispatch(discountFormAction({
                                   ...discountForm,
                                   name: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Размер скидки в процентах (указать число)</div>
                        <input type="number" className="input" value={ discountForm.percent }
                               onInput={ event => dispatch(discountFormAction({
                                   ...discountForm,
                                   percent: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...discountForm.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(discountFormAction({
                                                ...discountForm,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ discountForm.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(updateDiscountSagaAction({
                                     id: discountForm.id,
                                     name: discountForm.name,
                                     percent: discountForm.percent,
                                     establishments: JSON.stringify(discountForm.establishments)
                                 }));
                             } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscountForm;